import type { components, paths } from "@securityjourney/svc-audit/audit";

import { OpenApiFetchWrapper } from "./openApiFetchWrapper";

export type AuditEvent = components["schemas"]["securityjourney.proto.audit.AuditEvent"];
export type ListEventsResponse =
  components["schemas"]["securityjourney.proto.audit.ListEventsResponse"];

export type ListEventsOptions = NonNullable<
  paths["/svc/audit/{tenant}/events"]["get"]["parameters"]["query"]
>;

class AuditClient extends OpenApiFetchWrapper<paths> {
  async listEvents(tenant: string, options?: ListEventsOptions) {
    return await this.get("/svc/audit/{tenant}/events", {
      params: {
        path: { tenant },
        query: options,
      },
    });
  }
}

let auditClientInstance: AuditClient | null = null;

export const getAuditClient = (): AuditClient => {
  if (!auditClientInstance) {
    auditClientInstance = new AuditClient();
  }
  return auditClientInstance;
};
